// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__19tgh","additionalInfo":"AgreementModal_additionalInfo__jhxxX"};